import { render, staticRenderFns } from "./SliderItem.vue?vue&type=template&id=e93bb442&scoped=true&"
import script from "./SliderItem.vue?vue&type=script&lang=js&"
export * from "./SliderItem.vue?vue&type=script&lang=js&"
import style0 from "./SliderItem.vue?vue&type=style&index=0&id=e93bb442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93bb442",
  null
  
)

export default component.exports